import * as React from 'react';
import * as Elements from '../Legend.styles';
function getTitle(label, status, subLabel) {
    var title = subLabel !== undefined ? label + " - " + subLabel : label;
    if (status === 'empty')
        return title + ": *NO DATA";
    if (status === 'invalid')
        return title + ": *INVALID DATA";
    if (status === 'incomplete')
        return title + ": *INCOMPLETE";
    return title;
}
export var LegendChip = function (_a) {
    var active = _a.active, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, color = _a.color, label = _a.label, subLabel = _a.subLabel, onClick = _a.onClick, status = _a.status;
    var title = getTitle(label, status, subLabel);
    var isDisabled = status === 'empty' || status === 'invalid';
    var Icon = React.useMemo(function () { return React.createElement(Elements.Icon, { iconColor: color }); }, [label]);
    return (React.createElement(Elements.Item, { title: title, status: status, className: "LegendChip", onClick: onClick, active: active, wafer: subLabel === undefined, onMouseEnter: isDisabled ? undefined : onMouseEnter, onMouseLeave: isDisabled ? undefined : onMouseLeave, appearance: "outline", icon: isDisabled ? undefined : Icon, disabled: isDisabled },
        React.createElement(Elements.Label, null, label),
        subLabel !== undefined && (React.createElement(Elements.SubLabel, null, subLabel))));
};
//# sourceMappingURL=LegendChip.js.map